import UserInfo from './userInfo';
export default UserInfo;
